module.exports = __webpack_public_path__ + "img/home_product_msp.87b130cb.jpg";